import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import {
  activeProcessSF,
  getActiveProcessKey,
  handleProcess,
  IRydeProcess,
  RydeProcessTitle,
  RydeUiUnit,
  TAddressedFieldsValueOnCompleted,
  useProcesses,
} from "@ryde/shared";

export const useWatchBulkRideRecalculatePrice = ({
  entity,
  addressedFieldsValueOnCompleted,
}: {
  entity: RydeUiUnit;
  addressedFieldsValueOnCompleted: TAddressedFieldsValueOnCompleted;
}) => {
  const bulkRecalculatePriceProcessKey = getActiveProcessKey(
    RydeProcessTitle.BulkRecalculatePrice,
    entity,
  );

  const bulkRecalculatePriceProcess = useRecoilValue(
    activeProcessSF(bulkRecalculatePriceProcessKey),
  );
  const { stopProcessPolling } = useProcesses();
  const { t } = useTranslation();

  const onComplete = useCallback(
    (process: IRydeProcess) => {
      addressedFieldsValueOnCompleted(process);
    },
    [addressedFieldsValueOnCompleted],
  );

  useEffect(() => {
    handleProcess({
      entity,
      processTitle: RydeProcessTitle.BulkRecalculatePrice,
      process: bulkRecalculatePriceProcess,
      onComplete,
      translationFunction: t,
      stopProcessPolling,
    });
  }, [bulkRecalculatePriceProcess, entity, onComplete, stopProcessPolling, t]);
};
